var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-92a2dd34"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "relative pt-14 pb-16 section"
};
var _hoisted_2 = { class: "container" };
var _hoisted_3 = { class: "flex flex-col items-center" };
var _hoisted_4 = { class: "max-w-xl font-medium text-center text-3xl md:text-5xl" };
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = { class: "mt-10" };
var _hoisted_7 = { class: "flex flex-wrap justify-center sm:-mx-5" };
var _hoisted_8 = { class: "card__image mt-7 w-10 h-10 relative rounded-lg flex justify-center items-center" };
var _hoisted_9 = ["src"];
var _hoisted_10 = { class: "mt-5 text-center text-3xl" };
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = { class: "plan-list mt-5 w-full" };
var _hoisted_13 = { class: "plan-list-item__icon w-5 h-5 mr-2.5 flex items-center justify-center rounded-full bg-primary shrink-0" };
var _hoisted_14 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "flex-grow" }, null, -1); });
var _hoisted_15 = { class: "plan-price mt-5 flex flex-wrap items-center justify-center w-full" };
var _hoisted_16 = {
    key: 0,
    class: "line-through text-gray-400 flex items-center text-3xl font-medium"
};
var _hoisted_17 = { class: "ml-4 text-3xl font-medium text-right" };
var _hoisted_18 = {
    key: 0,
    class: "text-gray-400"
};
var _hoisted_19 = {
    key: 1,
    class: "text-red-400"
};
var _hoisted_20 = {
    key: 2,
    class: "text-gray-400"
};
import { CourseStore } from '@student/modules/store';
import { useLandingBlock } from '@student/components/Landing/Course/Blocks/useLandingBlock';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'OrderPlan',
    props: {
        landingBlock: {}
    },
    emits: ["buyCourse"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var t = useI18n().t;
        var _b = useLandingBlock(function () { return props.landingBlock; }), courseLanding = _b.courseLanding, landingCurrency = _b.landingCurrency, cards = _b.cards, showOrderForm = _b.showOrderForm, isLinkIcon = _b.isLinkIcon, parseTextWithUrl = _b.parseTextWithUrl;
        var mergedCards = computed(function () {
            return cards.value.map(function (card) {
                var _a, _b;
                var plan = CourseStore.plans.find(function (e) { return e.id === card.id; });
                var limitStudents = ((_a = plan === null || plan === void 0 ? void 0 : plan.group) === null || _a === void 0 ? void 0 : _a.limitStudents) || null;
                var studentsCount = ((_b = plan === null || plan === void 0 ? void 0 : plan.group) === null || _b === void 0 ? void 0 : _b.studentsCount) || 0;
                var leftLimitStudents = limitStudents ? limitStudents - studentsCount : null;
                var hasLimit = limitStudents !== null;
                var lastChange = 6 > leftLimitStudents || (limitStudents / 100 * 20) > leftLimitStudents;
                return __assign(__assign({}, card), { hasLimit: hasLimit, leftLimitStudents: leftLimitStudents, lastChange: lastChange });
            });
        });
        var buyPlan = function (plan) {
            showOrderForm(plan);
        };
        //Плюрализм
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            return (_unref(courseLanding).plansPayment)
                ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.landingBlock.title), 1),
                            (_ctx.landingBlock.subtitle)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: "mt-4 max-w-lg text-lg font-medium text-center",
                                    innerHTML: _unref(parseTextWithUrl)(_ctx.landingBlock.subtitle)
                                }, null, 8, _hoisted_5))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mergedCards.value, function (card) {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: card.id,
                                        class: "bg-white rounded-lg w-80 group relative flex flex-col items-center pt-5 pb-7 px-5 sm:m-5 shadow-custom"
                                    }, [
                                        _createElementVNode("div", _hoisted_8, [
                                            (card.image && !_unref(isLinkIcon)(card.image))
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: card.image,
                                                    alt: ""
                                                }, null, 8, _hoisted_9))
                                                : (card.image && _unref(isLinkIcon)(card.image))
                                                    ? (_openBlock(), _createBlock(_component_e_icon, {
                                                        key: 1,
                                                        icon: card.image,
                                                        class: "w-10 h-10 text-primary",
                                                        public: ""
                                                    }, null, 8, ["icon"]))
                                                    : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("h3", _hoisted_10, _toDisplayString(card.title), 1),
                                        (card.subtitle)
                                            ? (_openBlock(), _createElementBlock("p", {
                                                key: 0,
                                                class: "mt-4 text-center",
                                                innerHTML: card.subtitle
                                            }, null, 8, _hoisted_11))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("ul", _hoisted_12, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.list, function (el) {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    key: el,
                                                    class: "py-1.5 plan-list-item flex items-start py-1 px-2.5 rounded-lg"
                                                }, [
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _createVNode(_component_e_icon, {
                                                            class: "w-3 h-2.5 text-white",
                                                            icon: "check"
                                                        })
                                                    ]),
                                                    _createElementVNode("p", null, _toDisplayString(el), 1)
                                                ]));
                                            }), 128))
                                        ]),
                                        _hoisted_14,
                                        _createElementVNode("div", _hoisted_15, [
                                            (card.priceOld)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(card.priceOld) + " " + _toDisplayString(_unref(landingCurrency).symbol), 1))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_17, _toDisplayString(card.price) + " " + _toDisplayString(_unref(landingCurrency).symbol), 1)
                                        ]),
                                        (card.hasLimit && card.leftLimitStudents < 1)
                                            ? (_openBlock(), _createBlock(_component_e_button, {
                                                key: 1,
                                                class: "w-full mt-4",
                                                type: "white",
                                                disabled: ""
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createTextVNode(_toDisplayString(_unref(t)('buttons.noSeats')), 1)
                                                ]; }),
                                                _: 1
                                            }))
                                            : (_openBlock(), _createBlock(_component_e_button, {
                                                key: 2,
                                                class: "w-full mt-4",
                                                onClick: function ($event) { return (buyPlan(card)); }
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createTextVNode(_toDisplayString(_unref(t)('buttons.enroll')) + " " + _toDisplayString(card.price > 0 ? _unref(t)('buttons.andPay') : ''), 1)
                                                ]; }),
                                                _: 2
                                            }, 1032, ["onClick"])),
                                        _createElementVNode("div", {
                                            class: _normalizeClass([[
                                                    !card.hasLimit && 'opacity-0'
                                                ], "mt-2.5"])
                                        }, [
                                            (card.leftLimitStudents < 1 || !card.hasLimit)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_unref(t)('info.groupFull')), 1))
                                                : (card.lastChange)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_unref(t)('info.placeLeft', card.leftLimitStudents)) + "! ", 1))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_unref(t)('info.place', card.leftLimitStudents)), 1))
                                        ], 2)
                                    ]));
                                }), 128))
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
